<template>
  <v-navigation-drawer
    :value="value"
    @input="input => $emit('input', input)"
    fixed
    temporary
    right
    width="800"
  >
    <div style="min-height: 100%; overflow-y: hidden; background-color: #f1f3f4;" class="d-flex flex-column">
      <header class="pa-4 white d-flex align-center" style="font-size: 1.3em; height: 64px;">
        <v-btn icon @click="$emit('input', false)" class="mr-2">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <span>Novo pixel</span>
        <v-spacer></v-spacer>
        <v-btn color="secondary" depressed style="width: 150px;" :disabled="!isValid" @click="save()" :loading="loading">Adicionar</v-btn>
      </header>
      <v-divider></v-divider>
      <div class="d-flex flex-column justify-center align-center flex-grow-1 pa-4" style="overflow-y: auto;">
        <v-card outlined class="pa-4 d-flex flex-column" style="width: 100%; max-width: 400px;">
          <v-select
            label="Tipo"
            placeholder="Selecione"
            v-model="form.type"
            :items="[
              'Facebook Pixel',
              'Google Analytics',
              { text: 'Google Tag Manager', value: 'Google Tag Manager', disabled: !isActivePlan }
            ]"
            outlined
            hide-details
          ></v-select>
          <v-text-field
            class="mt-5"
            label="Dê um nome ao seu pixel"
            placeholder="Ex: Meu negócio"
            v-model="form.name"
            outlined
            hide-details
          ></v-text-field>
          <v-text-field
            class="mt-5"
            label="Insira o código do seu pixel"
            placeholder="Ex: 000000"
            v-model="form.identifier"
            outlined
            hide-details
          ></v-text-field>
          <v-textarea
            class="mt-5"
            v-if="form.type === 'Facebook Pixel'"
            :disabled="!isActivePlan"
            rows="3"
            label="Token (API de Conversões) [BETA]"
            :placeholder="isActivePlan ? 'Cole aqui' : 'Este recurso está restrito apenas para usuários pagos.'"
            v-model="form.token"
            outlined
            hide-details
          ></v-textarea>
        </v-card>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  props: ['value'],
  data () {
    return {
      loading: false,
      form: {
        name: '',
        identifier: '',
        type: 'Facebook Pixel'
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    },
    isValid () {
      return (this.form.name && this.form.identifier)
    }
  },
  methods: {
    async save () {
      this.loading = true

      try {
        await this.$store.dispatch('pixels/store', this.form)

        this.form = {
          name: '',
          identifier: '',
          type: 'Facebook Pixel'
        }

        this.$emit('input', false)
      } catch (e) {
        console.error(e)
        alert(e.message)
      }

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>